import { LayoutState } from '~/src/stores/layout'
import LayoutServiceInterface from '~/src/utils/layout/LayoutServiceInterface'

export default class LayoutAuthServiceStyleThree implements LayoutServiceInterface {
  public getLayout(): Partial<LayoutState> {
    return {
      header: {
        display: true,
        displayMenuBurger: true,
        displayProductSearch: false,
        displayLocationSearch: false,
        displayCart: false,
        displayLanguagesSelector: true,
        displayDeliveryOptions: false,
        displayUserActions: false,
        displayCurrentFirm: false,
        logo: {
          disableLink: false
        },
        title: '',
        type: 'navigation'
      },
      subHeader: {
        display: false,
        variant: 'small'
      },
      content: {
        displayNotification: false
      },
      mainSideBar: {
        display: false,
        displayCart: false,
        displayDeliveryOptions: false,
        displayOrderSummary: false
      },
      footer: {
        display: false,
        displayGoToCartBtn: false,
        displayGoToCheckoutBtn: false,
        displayInformations: true,
        displayLinks: true
      },
      mobileNavigation: {
        display: true
      }
    }
  }
}
